import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-me-posts',
  templateUrl: './me-posts.component.html',
  styleUrls: ['./me-posts.component.css']
})
export class MePostsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
